import React from 'react';
import { connect } from 'react-redux';
import type * as Types from '../../store/types';

type PermissionGateProps = {
  permission: {
    roles: string[];
  };
  children: React.ReactNode;
  fallback?: React.ReactNode;
  user?: Types.IAuthUser;
};

const PermissionGate: React.FC<PermissionGateProps> = ({
  permission,
  children,
  fallback = null,
  user,
}) => {
  const hasAccess = user ? permission.roles.includes(user.role) : false;

  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

const mapStateToProps = (store: Types.IPersistedState) => ({
  user: store.state.user,
});

export default connect(mapStateToProps)(PermissionGate);
